import React from "react";

import "./LoadingSpinner.scss";

export function LoadingSpinner() {
    return (
        <div className="loading-spinner-component">
            <div></div>
        </div>
    );
}
